import { Component, inject, HostListener } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { PlanExpiredService } from '../../services/plan-expired.service';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-plan-expired-modal',
  templateUrl: './plan-expired-modal.component.html',
  styleUrls: ['./plan-expired-modal.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class PlanExpiredModalComponent {
  private _planExpiredService = inject(PlanExpiredService);
  private _authService        = inject(AuthService);

  readonly isExpired$ = this._planExpiredService.isExpired$;

  readonly waLink = 'https://wa.link/l4gjr4';


  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: KeyboardEvent): void {
    if (this._planExpiredService.isExpiredValue()) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  upgrade(): void {
    window.open(this.waLink, '_blank', 'noopener,noreferrer');
  }

  logout(): void {
    this._authService.onLogout().subscribe({
      error: () => {
        console.log("Error")
      }
    });
  }
}
